var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: "1.707in",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 1707 1707",
    width: "1.707in",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1423 1690h-1139c-157 0-284-127-284-284v-1106c0-156 127-283 284-283h1139c156 0 283 127 283 283v1106c0 157-127 284-283 284z",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1706 837v569c0 87-38 164-100 216l-751-687c-20 6-35-19-19-34l303-280c95-88 244-83 347 12z",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bbbcbc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m636 548c-70 0-128-58-128-129 0-70 58-128 128-128 71 0 128 58 128 128 0 71-57 129-128 129z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m636 265c-28 0-20-42-20-81 0-27 40-27 40 0 0 39 8 81-20 81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m723 288c-15 0-25-16-17-30 19-34 34-74 58-60s-4 47-23 80c-4 7-11 10-18 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m787 352c-20 0-28-27-10-37 34-20 67-48 81-23 16 28-65 60-71 60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m872 439c-40 0-81 9-81-20 0-28 41-20 81-20 26 0 26 40 0 40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m840 557c-10 0-49-25-63-33-22-13-2-48 20-35 34 20 75 34 61 58-4 7-11 10-18 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m754 644c-18 0-31-35-48-63-13-23 21-43 35-20 12 21 58 83 13 83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m636 675c-28 0-20-41-20-81 0-26 40-26 40 0 0 39 8 81-20 81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m518 644c-15 0-25-17-17-30 19-34 34-75 58-61s-4 47-23 81c-4 6-11 10-18 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432 557c-20 0-28-27-10-37 34-20 66-47 80-23 15 24-26 38-60 58-3 1-7 2-10 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462 439c-40 0-82 9-82-20 0-28 42-20 82-20 26 0 26 40 0 40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485 352c-10 0-50-25-63-33-23-13-3-48 20-35 34 20 74 34 60 58-3 7-10 10-17 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m549 288c-18 0-32-34-48-63-13-22 21-43 35-20 12 21 58 83 13 83z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1423 1690h-1139c-157 0-284-127-284-284v-182l439-406c95-88 244-83 347 12l838 776c-51 52-122 84-201 84z",
    fill: "#7f8080"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.752e2de12f1b86be003171fadb086753.svg";
export { ForwardRef as ReactComponent };